import { z } from 'zod/v4'
import { paginationLinksSchema, paginationMetaSchema } from '@/lib/schema/v2/pagination'
import { zDayJs } from '@/lib/schema/v2/dayjs'
import { ampApiErrorSchema } from '@/lib/schema/v2/amp-api-response'

export const ticketStatusSchema = z.object({
    created_at: zDayJs.nullish(),
    name: z.string().nullish(),
    priority: z.number().nullish(),
    title: z.string().nullish(),
    updated_at: zDayJs.nullish(),
    uuid: z.uuid().nullish(),
})

export const ticketStatusesSchema = z.array(ticketStatusSchema)

export const paginatedTicketStatusesResponseSchema = z.object({
    data: ticketStatusesSchema.nullish(),
    links: paginationLinksSchema.nullish(),
    meta: paginationMetaSchema.nullish(),
    success: z.boolean(),
    error: ampApiErrorSchema.nullish(),
})

export const retrieveTicketStatusResponseSchema = z.object({
    data: ticketStatusSchema.nullish(),
    success: z.boolean(),
    error: ampApiErrorSchema.nullish(),
})

export type PaginatedTicketStatusesResponse = z.infer<typeof paginatedTicketStatusesResponseSchema>
export type TicketStatus = z.infer<typeof ticketStatusSchema>
export type TicketStatuses = z.infer<typeof ticketStatusesSchema>
export type RetrieveTicketStatusResponse = z.infer<typeof retrieveTicketStatusResponseSchema>
